import React, { useEffect } from 'react';
import '../../assets/css/views/login.css'
import logoAbeja from '../../assets/images/icon_beexqr.fw.png'
import logoBeex2 from '../../assets/images/logo_beex2.fw.png'

const generatePKCE = async () => {
	const array = new Uint8Array(32);
	window.crypto.getRandomValues(array);
	const codeVerifier = btoa(String.fromCharCode(...array))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	const encoder = new TextEncoder();
	const data = encoder.encode(codeVerifier);
	const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);

	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const base64 = btoa(String.fromCharCode(...hashArray))
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/, "");

	return { codeVerifier, codeChallenge: base64 };
};

export const Login = () => {
	// Solicitar permiso de notificación push cuando el componente se monte
	useEffect(() => {
		const requestNotificationPermission = async () => {
			if ('Notification' in window && navigator.serviceWorker) {
			try {
				const permission = await Notification.requestPermission();
				if (permission === 'granted') {
				// Aquí podrías agregar la lógica para registrar un service worker y suscribirte a las notificaciones push
				} else {
				}
			} catch (error) {
				console.error('Error al solicitar permisos de notificación:', error);
			}
			}
		};

		// Llamar la función para solicitar permiso
		requestNotificationPermission();
	}, []);
	
	const scopesUsuario = process.env.REACT_APP_SCOPES_TOKEN

    const rolesScopes = [
      {nombre: "Administrador", descripcion: "Acceso Total",scopes: scopesUsuario},
      {nombre: "Recargador", descripcion: "Validar recargas ",scopes: scopesUsuario},
      {nombre: "Enlazador", descripcion: "Creación y enlace de QRs con unidades",scopes: scopesUsuario},
    ]

    const iniciarSesionConAbexa = async (scopes) => {
		const result = await generatePKCE();
		localStorage.setItem("pkce", JSON.stringify(result))

		const searchParameters = new URLSearchParams({
			response_type: 'code',
			client_id: process.env.REACT_APP_WSO2IS_CLIENT_ID,
			redirect_uri: process.env.REACT_APP_REDIRECT_URI,
			scope: scopes,
			state: 'ThisIsMyStateValue',
			code_challenge: result.codeChallenge,
			code_challenge_method: 'S256',
			id_carga: Date.now()
		})
		const urlEnvio = `${process.env.REACT_APP_WSO2IS_AUTHORIZATION}/authorize?` + searchParameters
		try {
			localStorage.setItem("scopes",scopes)
			window.location.href = urlEnvio;
		} catch (error) {
			console.error('Error en la solicitud:', error);
		}
    }


    return (
        <>  
          <div className="flex h-screen lg:flex-col overflow-y-hidden">
            <div className='flex flex-col items-end lg:items-center lg:pt-5 justify-center lg:w-full w-[50%] bg-slate-900'>
              <div className='flex flex-col items-center px-5 mb-10 '>
                <img className='animate-flap-wings container w-auto' src={logoAbeja} alt=''/>
                <img className='w-auto container' src={logoBeex2} alt=''/>
              </div>
            </div>

            <div className="flex flex-col items-start lg:items-center lg:justify-start lg:pt-5 justify-center lg:w-full lg:h-full text-2xl text-white w-[50%] bg-gray-800 ">
              <div className=' flex flex-col  max-h-[70%] containerScroll overflow-y-auto'>
                <div className='flex mx-10'>Iniciar Sesión</div>
                {
                  rolesScopes?.map((rs, i)=>( 
                    <div key={i+1} className={`flex flex-col m-1`}>
                      <button 
                          onClick={()=>iniciarSesionConAbexa(rs.scopes)}
                          key={i}
                          className={`bg-blue-800 hover:bg-blue-700 text-xl py-2 px-10 rounded`}
                      >{rs.nombre}</button>
                    </div>
                  ))
                }
              </div>
            </div>
      
          </div>
        </>
	);
}

